import PropTypes from "prop-types";

// @mui material components
import Container from "@mui/material/Container";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import Icon from "@mui/material/Icon";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

function BookingTerms({ accepted, onAcceptChange, pricingConfig }) {
  const depPct = Math.round((pricingConfig?.minimumDepositPercent || 0.5) * 100);
  const balPct = 100 - depPct;

  return (
    <MKBox component="section" py={4}>
      <Container maxWidth="sm">
        <MKBox bgColor="grey-100" borderRadius="xl" p={3}>
          <MKTypography variant="h5" mb={2}>
            <Icon sx={{ mr: 1, verticalAlign: "middle" }}>policy</Icon>
            Cancellation &amp; Refund Policy
          </MKTypography>
          <MKBox display="flex" mb={1}>
            <Icon sx={{ mr: 1, fontSize: "1rem", mt: 0.3, flexShrink: 0, color: "success.main" }}>
              check_circle
            </Icon>
            <MKTypography variant="body2" color="dark">
              <strong>Full refund</strong> if cancelled within 3 days of booking.
            </MKTypography>
          </MKBox>
          <MKBox display="flex" mb={1}>
            <Icon sx={{ mr: 1, fontSize: "1rem", mt: 0.3, flexShrink: 0, color: "error.main" }}>
              cancel
            </Icon>
            <MKTypography variant="body2" color="dark">
              <strong>No refund</strong> if cancelled after 3 days &mdash; the {depPct}% deposit is
              non-refundable.
            </MKTypography>
          </MKBox>
          <MKBox display="flex" mb={8}>
            <Icon sx={{ mr: 1, fontSize: "1rem", mt: 0.3, flexShrink: 0, color: "info.main" }}>
              info
            </Icon>
            <MKTypography variant="body2" color="dark">
              The remaining {balPct}% balance is due upon arrival at the property.
            </MKTypography>
          </MKBox>
          <FormControlLabel
            control={
              <Checkbox
                checked={accepted}
                onChange={(e) => onAcceptChange(e.target.checked)}
                sx={{
                  color: "grey.400",
                  "&.Mui-checked": { color: "info.main" },
                  "& .MuiSvgIcon-root": {
                    fontSize: 28,
                    backgroundColor: "#a3a3a3",
                    borderRadius: "4px",
                  },
                  "&.Mui-checked .MuiSvgIcon-root": { backgroundColor: "transparent" },
                }}
              />
            }
            label={
              <MKTypography variant="body2" color="dark" fontWeight="medium">
                I have read and agree to the house rules, check-in/checkout times, and cancellation
                policy.
              </MKTypography>
            }
          />
        </MKBox>
      </Container>
    </MKBox>
  );
}

BookingTerms.propTypes = {
  accepted: PropTypes.bool.isRequired,
  onAcceptChange: PropTypes.func.isRequired,
  pricingConfig: PropTypes.object,
};

export default BookingTerms;
